import React from "react";
import MarketScoutReport from "./MarketScoutReport";

export default function App() {
  return <MarketScoutReport />;
}
